const defaultstate = { vaultsSearch: [] }

export default function (state = defaultstate, action) {
    switch (action.type) {
        case 'FOR_SEARCH':
            return {
                ...state,
                vaultsSearch: action.payload
            };
        default:
            return state
    }
}